/** */

import {
  ADD_MANY_LEAD_TO_STORE,
  ADD_ONE_LEAD_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_LEADS_TO_STORE,
  REMOVE_MANY_LEAD_FROM_STORE,
  REMOVE_ONE_LEAD_FROM_STORE,
  UPDATE_ONE_LEAD_IN_STORE
} from '../actions/lead';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_LEAD_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (leads, lead) => ({
            ...leads,
            [lead.id]: lead
          }),
          {}
        )
      };
    case LOAD_LEADS_TO_STORE:
      return {
        ...payload.reduce(
          (leads, lead) => ({
            ...leads,
            [lead.id]: lead
          }),
          {}
        )
      };

    case REMOVE_MANY_LEAD_FROM_STORE:
      previous_state = { ...state };
      payload.forEach((id) => delete previous_state[id]);
      return {
        ...previous_state
      };

    case REMOVE_ONE_LEAD_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };

    case ADD_ONE_LEAD_TO_STORE:
      return {
        [payload.id]: payload,
        ...state
      };

    case UPDATE_ONE_LEAD_IN_STORE:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          ...payload
        }
      };

    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (leads, lead) => ({
            ...leads,
            [lead.id]: lead
          }),
          {}
        )
      };

    default:
      return state;
  }
};
